<div class="empathy-preview-variables">
  <div class="empathy-preview-variables__title">
    <span class="fs__xl">Source Variables</span>
    @if (sources$().length > 0) {
      <div class="empathy-preview-variables__actions">
        <button mat-stroked-button data-testid="survey-preview-variables-reset-button" [disabled]="disabled$()" (click)="onReset()"><span>Reset</span></button>
        <button
          mat-flat-button
          color="primary"
          data-testid="survey-preview-variables-apply-button"
          [disabled]="disabled$() || !allowApply$()"
          (click)="onApply()"
        >
          <span>Apply variables</span>
        </button>
      </div>
    }
  </div>
  <div class="empathy-preview-variables__content">
    @if (sources$().length > 0) {
      <div class="editor-question-form__input">
        <span class="label">Select a source</span>
        <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
          <mat-select
            [(ngModel)]="selectedSource$"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="disabled$()"
            aria-label="Pick a source to apply"
            data-testid="survey-preview-source-select"
          >
            @for (source of sources$(); track $index) {
              <mat-option [value]="source.value" [attr.data-testid]="'survey-preview-source-' + $index + '-option'"
                ><span>{{ source.text }}</span></mat-option
              >
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (filteredSourceVariables$().length > 0) {
        <div class="empathy-preview-variables__form">
          <span class="fs__lg">Variables</span>
          @for (variable of filteredSourceVariables$(); track variable.token) {
            <div class="editor-question-form__input">
              <span class="label">{{ variable.token }}</span>
              <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
                @if (variable.options.length > 0) {
                  <mat-select
                    [(ngModel)]="variable.value"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="disabled$()"
                    [attr.data-testid]="'survey-preview-variable-' + variable.token + '-select'"
                    aria-label="Pick a variable option"
                  >
                    <mat-option [value]="''" [attr.data-testid]="'survey-preview-variable-' + variable.token + '-empty-option'"></mat-option>
                    @for (option of variable.options; track $index) {
                      <mat-option [value]="option.value" [attr.data-testid]="'survey-preview-variable-' + variable.token + '-' + $index + '-option'">
                        <span>{{ option.text }}</span>
                      </mat-option>
                    }
                  </mat-select>
                } @else {
                  <input
                    matInput
                    [(ngModel)]="variable.value"
                    [disabled]="disabled$()"
                    [attr.data-testid]="'survey-preview-variable-' + variable.token + '-input'"
                    autocomplete="off"
                  />
                }
              </mat-form-field>
            </div>
          }
        </div>
      }
    } @else {
      <p class="empathy-preview-variables__no-configured fs__md fw__600">No source variables configured for this survey</p>
    }
  </div>
</div>
